export type CheckedState = "checked" | "unchecked" | "intermediate";